/** @jsx jsx */
import clsx from 'clsx'
import React from 'react'
import { css, jsx } from '@emotion/react'
import { Icon } from '../../utils/Icon'
import { color } from '../../utils/Style'
import { CircleStatusIcon } from '../CircleStatusIcon'

type InfoModalProps = {
  open?: boolean
  handleClose: VoidFunction
}

export const InfoModal = ({ open, handleClose }: InfoModalProps) => {
  return (
    <div
      id="info_modal"
      className={clsx('Modal', open && '-opened')}
      onClick={handleClose}
    >
      <div className="Modal__inner">
        <div
          className="Modal__dialog"
          data-target="modal.dialog"
          css={modalStyle}
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <CloseButton onClose={handleClose} />
          <div
            style={{
              display: 'grid',
              gap: '16px',
              fontWeight: 700,
              lineHeight: '25.6px',
            }}
          >
            <span
              style={{
                fontSize: '18px',
                fontWeight: 500,
                color: color.colorBjTextSub,
              }}
            >
              空き状況の説明
            </span>
            <span
              style={{
                color: color.colorVacancies,
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <CircleStatusIcon
                statusCode="vacancies"
                size="md"
                style={{ marginRight: '8px' }}
              />
              空きあり
            </span>
            <span
              style={{
                color: color.colorVacanciesLittle,
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <CircleStatusIcon
                statusCode="vacancies_little"
                size="md"
                style={{ marginRight: '8px' }}
              />
              もうすぐ満室
            </span>
            <span
              style={{
                color: color.colorBjAzRed,
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <CircleStatusIcon
                statusCode="full"
                size="md"
                style={{ marginRight: '8px' }}
              />
              キャンセル待ち
            </span>
            <hr
              style={{
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                borderColor: color.colorScSeparator,
              }}
            />
            <span
              style={{
                fontWeight: 400,
                fontSize: '14px',
                color: color.colorScTextHeading,
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <svg
                style={{ marginRight: '8px' }}
                width="24"
                height="28"
                viewBox="0 0 24 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect y="5" width="24" height="23" rx="2" fill="#7F7D76" />
                <path
                  d="M8.49716 15.3674C9.56859 17.5047 11.2948 19.2492 13.4004 20.3443L15.0373 18.6828C15.2382 18.4789 15.5359 18.4109 15.7963 18.5016C16.6296 18.781 17.5299 18.932 18.4525 18.932C18.8617 18.932 19.1966 19.2719 19.1966 19.6872V22.3229C19.1966 22.7383 18.8617 23.0781 18.4525 23.0781C11.4659 23.0781 5.80371 17.331 5.80371 10.2396C5.80371 9.82422 6.13853 9.48438 6.54776 9.48438H9.15193C9.56115 9.48438 9.89597 9.82422 9.89597 10.2396C9.89597 11.1836 10.0448 12.0898 10.3201 12.9357C10.4019 13.2 10.3424 13.4945 10.1341 13.706L8.49716 15.3674Z"
                  fill="white"
                />
              </svg>
              テオテ病児保育
              <br />
              未導入施設
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const CloseButton = (props: { onClose: VoidFunction }) => {
  return (
    <span
      role="button"
      aria-label="閉じる"
      css={closeButtonStyle}
      onClick={props.onClose}
    >
      <Icon
        iconName="close-circle"
        style={{
          color: color.colorBjTextSub,
        }}
      />
    </span>
  )
}

const closeButtonStyle = css`
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px;
  cursor: pointer;
  transform: translate(14px, -14px);
  & > svg {
    border-radius: 9999px;
    width: 26px;
    height: 26px;
    display: block;
    outline: 2px solid ${color.colorBjTextSub};
    outline-offset: -2px;
  }
`

const modalStyle = css`
  border: 1px solid ${color.colorScSeparator};
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  padding: 16px 22px;
`
